module.exports = __webpack_public_path__ + "5ea735906e2b688d3fddd9b89ea902a3.svg";